import React, { useContext } from 'react';
import { ModalContext } from 'App';
// import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import ApproveConfirmationRenewalModal from '../modals/ApproveConfirmationRenewalModal';

const useApproveConfirmationRenewal = (
  isLoading,
  isStartAssessment,
  refreshList,
  transactionStatus,
  id,
) => {
  const setModal = useContext(ModalContext);
  const isStatusAllowed = ['ONGOING'].indexOf(transactionStatus) > -1;
  const showComponent = isStartAssessment && isStatusAllowed;
  const onHandleClick = e => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <ApproveConfirmationRenewalModal id={id} refreshList={refreshList} />,
      title: `Confirmation`,
      modalSize: 'modal-md',
    });
  };

  const component = showComponent ? (
    <div className="mx-2 mb-2">
      <button
        disabled={isLoading}
        onClick={onHandleClick}
        type="button"
        className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold   "
      >
        {isLoading && (
          <>
            <i className="fas fa-spinner fa-spin" />
            &nbsp;
          </>
        )}
        Approve
      </button>
    </div>
  ) : null;

  return {
    onHandleClick,
    component,
  };
};

export default useApproveConfirmationRenewal;
